import { render, staticRenderFns } from "./home-btn.vue?vue&type=template&id=3b8392f4&scoped=true&lang=pug&"
import script from "./home-btn.vue?vue&type=script&lang=coffee&"
export * from "./home-btn.vue?vue&type=script&lang=coffee&"
import style0 from "./home-btn.vue?vue&type=style&index=0&id=3b8392f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8392f4",
  null
  
)

export default component.exports